'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

exports.default = function (object) {
  if ((0, _lodash.isObject)(object)) {
    return Object.keys(object).reduce(function (ret, item) {
      var prefix = !ret ? '' : ret + '&';

      return prefix + encodeURIComponent(item) + '=' + ((0, _lodash.isArray)(object[item]) ? encodeURIComponent(object[item].map(function (d) {
        return JSON.stringify(d);
      }).join(',')) : encodeURIComponent(object[item]));
    }, '');
  }

  return object;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/utils/toQueryString.js
// module id = G1EW
// module chunks = 4